import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "a",
  fill: "#fff"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 0h22v22H0z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M0 0h22v22H0z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M0 0v-3h-3v3zm0 3h22v-6H0zm3 19V0h-6v22z",
  mask: "url(#a)"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }